import {
  IReportInfo,
  ReportPageT,
  IssueDistributionT,
  ActiveThirdPartyVulnerabilitiesT,
  IHandledResponse
} from '~/types/reportTypes'
import { GraphqlQueryResponse } from '~/types/apollo-graphql-types'
import { RepositoryScaTargetReportItem } from '~/types/types'
import { resolveNodes } from '~/utils/array'

type Target = Pick<
  RepositoryScaTargetReportItem,
  | 'id'
  | 'repository'
  | 'packageManager'
  | 'manifestPath'
  | 'lockfilePath'
  | 'criticalSeverityVulnerabilityCount'
  | 'highSeverityVulnerabilityCount'
  | 'mediumSeverityVulnerabilityCount'
  | 'lowSeverityVulnerabilityCount'
>

const RECENTLY_UPDATED_TARGETS_INFO: IReportInfo = {
  key: ReportPageT.SCA_TARGETS,
  query: 'scaTargetsReport',
  componentName: 'PinnedRecentlyUpdatedTargetsList',
  handleResponse: (
    response: GraphqlQueryResponse,
    _filter?: IssueDistributionT | ActiveThirdPartyVulnerabilitiesT
  ): IHandledResponse => {
    const targetsList = response.data.owner
      ? (resolveNodes(response.data.owner.mostRecentScaTargets) as Array<Target>)
      : []
    return {
      targetsList,
      label: 'Recently Updated Targets'
    }
  }
}

export default RECENTLY_UPDATED_TARGETS_INFO
